import {
  FC,
  HTMLInputTypeAttribute,
  InputHTMLAttributes,
  useEffect,
  useState,
} from 'react';
import PlusSvg from 'assets/icons/plus.svg';
import AddFeatureModal from './AddFeatureModal';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  disabled?: boolean;
  touched?: any;
  type?: HTMLInputTypeAttribute;
  name?: string;
  placeholder?: string;
  error?: string;
  label?: string;
  required?: boolean;
  headText?: string;
  setFieldValue?: any;
}

const PropertyFeatures: FC<InputProps> = ({
  className,
  disabled,
  touched,
  type,
  name,
  placeholder,
  error,
  label,
  headText,
  setFieldValue,
  ...rest
}) => {
  const wales = 'lets';

  const [items, setItems] = useState<[]>([]);
  const [showModal, setShowModal] = useState<boolean>(false);

  useEffect(() => {
    const newValuePairs = Object.fromEntries(
      items.map((item) => Object.values(item))
    );
    setFieldValue(newValuePairs);
  }, [items]);

  return (
    <div>
      <AddFeatureModal
        showModal={showModal}
        setShowModal={setShowModal}
        items={items}
        setItems={setItems}
      />
      {label && (
        <label className="text-white text-lg mb-2" htmlFor={name}>
          {label}
        </label>
      )}
      {headText && (
        <p className="text-white opacity-75 text-xs my-4">{headText}</p>
      )}
      <div
        className={`${
          error ? 'border-red-500' : 'border-primary-2'
        } flex justify-between border p-2`}
      >
        <div className="flex flex-wrap">
          {items.length ? (
            items.map(({ key, value }) => (
              <div className="flex mr-2 mt-1 bg-primary-2 p-1 rounded text-white">
                <p className="text-xs">{key} -</p>{' '}
                <p className="text-xs">{value}</p>
              </div>
            ))
          ) : (
            <p className="text-white opacity-70 text-base">Enter key</p>
          )}
        </div>

        <div
          role="button"
          className="mr-2 mt-1"
          aria-hidden="true"
          onKeyDown={() => setShowModal(true)}
          onClick={() => setShowModal(true)}
        >
          <img src={PlusSvg} alt="plus svg" />
        </div>
      </div>
      {error && touched && <p className="text-red-700 text-xs my-4">{error}</p>}
    </div>
  );
};

export default PropertyFeatures;
